import React, { useState } from 'react';
import { Calendar, Tag, ExternalLink } from 'lucide-react';
import { noticias } from '../mock';

const Noticias = () => {
  const [selectedCategory, setSelectedCategory] = useState('todas');

  const categorias = [
    { id: 'todas', nombre: 'Todas' },
    { id: 'empleo', nombre: 'Empleo' },
    { id: 'economia', nombre: 'Economía' },
    { id: 'programas', nombre: 'Programas' },
    { id: 'eventos', nombre: 'Eventos' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1920&q=80" 
            alt="Noticias"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="text-5xl font-bold text-white mb-4">Noticias</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Mantente informado sobre las últimas novedades, eventos y programas de la Secretaría de Economía y Trabajo de Yucatán.
          </p>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Category Filter */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-3">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                onClick={() => setSelectedCategory(categoria.id)}
                className={`px-5 py-2 rounded-lg font-medium transition-all ${
                  selectedCategory === categoria.id
                    ? 'bg-[#8B1538] text-white'
                    : 'bg-white text-gray-700 border border-gray-200 hover:border-gray-300 hover:shadow-sm'
                }`}
              >
                {categoria.nombre}
              </button>
            ))}
          </div>
        </div>

        {/* Featured News */}
        <div className="mb-12">
          <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-lg hover:shadow-xl transition-shadow">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative h-80 lg:h-auto">
                <img
                  src={noticias[0].imagen}
                  alt={noticias[0].titulo}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-gray-900 text-white text-xs font-medium rounded-full">
                    Destacada
                  </span>
                </div>
              </div>
              
              <div className="p-8 flex flex-col justify-center">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                  <div className="flex items-center gap-1">
                    <Calendar className="h-4 w-4" />
                    <span>{noticias[0].fecha}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Tag className="h-4 w-4" />
                    <span>Economía Digital</span>
                  </div>
                </div>
                
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  {noticias[0].titulo}
                </h2>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {noticias[0].extracto}
                </p>
                
                <button className="self-start px-6 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium flex items-center gap-2">
                  Leer Artículo Completo
                  <ExternalLink className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* News Grid */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Últimas Noticias</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {noticias.slice(1).map((noticia) => (
            <div
              key={noticia.id}
              className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-lg hover:border-gray-300 transition-all duration-300 flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={noticia.imagen}
                  alt={noticia.titulo}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <Calendar className="h-4 w-4" />
                  <span>{noticia.fecha}</span>
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                  {noticia.titulo}
                </h3>
                
                <p className="text-sm text-gray-600 mb-4 line-clamp-3 flex-grow">
                  {noticia.extracto}
                </p>
                
                <button className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors flex items-center gap-2">
                  Leer más
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        <div className="mt-12 text-center">
          <button className="px-8 py-3 bg-white text-gray-900 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium">
            Cargar Más Noticias
          </button>
        </div>
      </div>
    </div>
  );
};

export default Noticias;
